import styled from 'styled-components'

export const AccordionWrapper = styled.div`
  & summary > div {
    margin: 0;
  }

  & summary > div > div {
    margin: 0;
  }

  & label {
    max-width: max-content;
  }
`
